module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Rothrist_AG-8f71da285af19a3ad447a848ddd438e8.svg";